<template>
    <div :is="'reservation-payment'" :reservationCreation="true" :direction="0">cenas</div>
</template>

<script>
    import ReservationPayment from './ReservationPayment'

    export default {
        components: {
            ReservationPayment,
        },
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ReservationPay.vue?8a78d9b4